import axios from 'axios';
export const prodUrl = "https://seller.gostor.com"
export const ALLOWED_USERS = [9110870398,8758801029]
// const isProd = 'REACT_APP_ENVIRONMENT' in process.env && process.env.REACT_APP_ENVIRONMENT === 'prod';
// const isTest = 'REACT_APP_ENVIRONMENT' in process.env && process.env.REACT_APP_ENVIRONMENT === 'test'
const isProd = window.location.hostname === 'seller.gostor.com'
const isTest = window.location.hostname === 'seller.dev.gostor.com'
let hostApi=''
let inventoryApi = ''
if(isProd)
    hostApi='https://apigateway.gostor.com/gostorbe/'
else if (isTest)
    hostApi='https://apigateway.dev.gostor.com/gostorbe/'
else
    hostApi='https://apigateway.dev.gostor.com/gostorbe/'

if(isProd)
    inventoryApi='https://apigateway.gostor.com/inventory/'
else if (isTest)
    inventoryApi='https://apigateway.dev.gostor.com/inventory/'
else
    inventoryApi='https://apigateway.dev.gostor.com/inventory/'

 const instance = axios.create({
    baseURL : hostApi
})
const inventoryInstance = axios.create({
    baseURL: inventoryApi
})

const refreshToken = async (token)=>{
    let newRes = await instance.post(`user/seller/refresh_token`,  { refreshToken: token.refreshToken })
        let token_obj = {
            accessToken: newRes.data.accessToken,
            refreshToken: token.refreshToken
        } 
            
        localStorage.setItem('token', JSON.stringify(token_obj));
        return newRes;
}

const sessionExpired = ()=>{
    localStorage.clear();
    return (window.location.href = '/login');
}

const get = async (url, param, time, withCred, isMargin = false) => {
    const axiosConfig = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }
    const token = localStorage.getItem("token") ? JSON.parse(localStorage.getItem("token")) : {};
    axiosConfig.headers.Authorization = 'Bearer '.concat(token.accessToken);
    if(time) axiosConfig.timeout = time.timeout
    if(param) axiosConfig.params = param.params
    let res;
    let respo;

    if(withCred && !withCred.withCredentials){
        if(withCred.headers){
            if(withCred.headers["Content-Type"] === undefined){
                axiosConfig.headers["Content-type"] = undefined
            }
            else{
                axiosConfig.headers["Content-type"] = withCred.headers["Content-Type"]
            }
            res = await instance.get(url, axiosConfig);
            if (isMargin) {
                res = await inventoryInstance.get(url, axiosConfig);
            } else {
                res = await instance.get(url, axiosConfig);
            }
        }
        else {
            if (isMargin) {
                res = await inventoryInstance.get(url, axiosConfig);
            } else {
                res = await instance.get(url);
            }
        }
        respo = res;
    }

    else{
        res = await instance.get(url, axiosConfig);
        if(res.data.msg === 'Invalid Token'){
            return sessionExpired();
        }
        if(res.data.msg === 'Token Expired'){
            let newRes = await refreshToken(token);

            axiosConfig.headers.Authorization =  'Bearer '.concat(newRes.data.accessToken);

            res = await instance.get(url, axiosConfig)
            if(res.data.msg === 'Invalid Token'){
                return sessionExpired();
            }
        }
        respo = res;
    }

    // let res = await instance.get(url, axiosConfig );
    // let respo;
    // if(res.data.msg === 'Invalid Token'){
    //     return sessionExpired();
    // }
    // if(res.data.msg === 'Token Expired'){

    //     let newRes = await refreshToken(token);
    //     axiosConfig.headers.Authorization =  'Bearer '.concat(newRes.data.accessToken);
    //     let response = await instance.get(url, axiosConfig)

    //     if(response.data.msg === 'Invalid Token'){
    //         return sessionExpired();
    //     }

    //     respo = response; 
    // }
    // else{
    //     respo = res;
    // }
    return respo;
}


//// It is an axios delete wraper////
const remove = async (url)=>{
    const axiosConfig = {
        headers : {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }
    const token = localStorage.getItem("token") ? JSON.parse(localStorage.getItem("token")) : {};
    axiosConfig.headers.Authorization = 'Bearer '.concat(token.accessToken);
    let res = await instance.delete(url, axiosConfig );
    let respo;
    if(res.data.msg === 'Invalid Token'){
        return sessionExpired();
    }
    if(res.data.msg === 'Token Expired'){

        let newRes = await refreshToken(token);
        axiosConfig.headers.Authorization =  'Bearer '.concat(newRes.data.accessToken);
        let response = await instance.delete(url, axiosConfig)

        if(response.data.msg === 'Invalid Token'){
            return sessionExpired();
        }

        respo = response; 
    }
    else{
        respo = res;
    }
    return respo;
}

const post = async (url, data, withCred, isMargin = false) => {
    const axiosConfig = {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }
    const token = localStorage.getItem("token") ? JSON.parse(localStorage.getItem("token")) : {};
    axiosConfig.headers.Authorization = 'Bearer '.concat(token.accessToken);
    let res;
    let respo;
    if (withCred && !withCred.withCredentials) {
        if (withCred.headers) {
            if (withCred.headers["Content-Type"] === undefined) {
                axiosConfig.headers["Content-type"] = undefined
            }
            else {
                axiosConfig.headers["Content-type"] = withCred.headers["Content-Type"]
            }
            res = await instance.post(url, data, axiosConfig);
        }
        else {
            if (isMargin) {
                res = await inventoryInstance.post(url, data, axiosConfig);
            } else {
                res = await instance.post(url, data);
            }
        }
        respo = res;
    }
    else {
        res = await instance.post(url, data, axiosConfig);
        if (res.data.msg === 'Invalid Token') {
            return sessionExpired();
        }
        if (res.data.msg === 'Token Expired') {
            let newRes = await refreshToken(token);

            axiosConfig.headers.Authorization = 'Bearer '.concat(newRes.data.accessToken);

            res = await instance.post(url, data, axiosConfig);
            if (res.data.msg === 'Invalid Token') {
                return sessionExpired();
            }
        }
        respo = res;
    }
    return respo;
}

const put = async (url, data)=>{
    const axiosConfig = {
        headers : {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }
    const token = localStorage.getItem("token") ? JSON.parse(localStorage.getItem("token")) : {};
    axiosConfig.headers.Authorization = 'Bearer '.concat(token.accessToken);
    let res = await instance.put(url, data, axiosConfig);
    if(res.data.msg === 'Invalid Token'){
        return sessionExpired();
    }
    if(res.data.msg === 'Token Expired'){
        let newRes = await refreshToken(token);

        axiosConfig.headers.Authorization =  'Bearer '.concat(newRes.data.accessToken);
        
        res = await instance.put(url, data, axiosConfig);
        if(res.data.msg === 'Invalid Token'){
            return sessionExpired();
        }
    }

    return res;
}
const patch = async (url, data)=>{
    const axiosConfig = {
        headers : {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    }
    const token = localStorage.getItem("token") ? JSON.parse(localStorage.getItem("token")) : {};
    axiosConfig.headers.Authorization = 'Bearer '.concat(token.accessToken);
    let res = await instance.patch(url, data, axiosConfig);
    if(res.data.msg === 'Invalid Token'){
        return sessionExpired();
    }
    if(res.data.msg === 'Token Expired'){
        let newRes = await refreshToken(token);

        axiosConfig.headers.Authorization =  'Bearer '.concat(newRes.data.accessToken);
        
        res = await instance.patch(url, data, axiosConfig);
        if(res.data.msg === 'Invalid Token'){
            return sessionExpired();
        }
    }

    return res;
}

const API = {get, post, remove, put,patch};

export default API;

